import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import {useLang} from '../../context/LanguageContext';
import {useAuth} from "../../context/AuthContext";
import Api from "../../utils/Api";
import {FaArrowLeft} from "react-icons/fa";
import useSubscriptions from "../../hooks/useSubscriptions";
import Loading from "../../components/Loading";
import DateUtils from "../../utils/dateUtils";
import Dots3 from "../../images/3dots.svg";


const MySubscriptionPage = () => {
    const { customerId } = useAuth();
    const navigate = useNavigate();
    const subscriptions = useSubscriptions();
    const { t } = useLang();
    const [subscription, setSubscription] = useState(null);
    const [sub, setSub] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [showMessage, setShowMessage] = useState(false);


    useEffect(() => {
        const getSubscription = async () => {
            const userSubscriptions = await Api.checkSubscription(customerId);
            if(!userSubscriptions){
                return ;
            }
            const activeSubscriptions = userSubscriptions.filter(sub => (sub.status === "active" || sub.status === "trialing"));
            if(activeSubscriptions.length > 0){
                setSubscription(activeSubscriptions[0]);
            }else{
                setSubscription(userSubscriptions[0]);
            }
        }
        getSubscription();

    }, [customerId]);

    useEffect(() => {
        const priceId = subscription?.plan?.id;
        if(!priceId){
            return ;
        }
        const userSubscriptionData = subscriptions.find(sub => sub.priceId === priceId);
        setSub(userSubscriptionData)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subscription])

    if(!subscription || !sub){
        return (
            <div className="relative min-h-screen bg-gray-100 p-5">
                <button
                    onClick={() => navigate('/account')}
                    className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
                >
                    <FaArrowLeft />
                    <span className="text-white">{t('btn.back')}</span>
                </button>
                <Loading />
            </div>
        )
    }

    const unsubscribe = async () => {
        const confirmChoice = window.confirm(t('subs.confirmTitle'))
        if(confirmChoice){
            await Api.cancelSubscription(subscription.id)
            setShowDetails(false);
            setShowMessage(true);
        }
    }

    let showMessageClass = 'hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 size-full fixed top-0 start-0 z-[80] overflow-x-hidden transition-all overflow-y-auto bg-[rgba(0,0,0,0.6)] items-center flex m-0 ';
    if(!showMessage){
        showMessageClass += ' hidden opacity-0'
    }

    return (
        <div className="relative min-h-screen bg-gray-100 p-5">
            <button
                onClick={() => navigate('/account')}
                className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
            >
                <FaArrowLeft />
                <span className="text-white">{t('btn.back')}</span>
            </button>

            <div className="max-w-[700px] mx-auto space-y-6">
                <div className="flex justify-between mt-16 mb-8 ">
                    <h1 className="text-xl font-bold text-center flex items-center">
                        {t('subs.activeSubTitle')}
                    </h1>

                </div>

                <h3>
                    {t('subs.type')}: {t('subs.name')} {sub.title}
                </h3>
                <h3>
                    {t('subs.status')}: {t('subs.status_' + subscription.status)}
                </h3>
                <h3>
                    {t('subs.dateStart')}: {DateUtils.getDay(subscription.start_date)}
                </h3>
                <h3>
                    {t('subs.dateEnd')}: {DateUtils.getDay(subscription.current_period_end)}
                </h3>
                {subscription.cancel_at_period_end &&
                    <h3>
                        {t('subs.subActiveCanceled')}
                    </h3>
                }

                {!subscription.cancel_at_period_end &&
                    <button
                        onClick={() => setShowDetails(true)}
                        className="flex items-center space-x-2"
                    >
                        {/*{t('btn.details')}*/}
                        <img src={Dots3} alt="alt" className="h-[34px]"/>
                    </button>
                }

                {showDetails === true &&
                    <div className="relative bg-gray-200 p-5">
                        <h1 className="flex justify-between">
                            {t('subs.detailsTitle')}
                            <button onClick={() => setShowDetails(false)}
                                    className="px-4 py-2 bg-gray-300 rounded flex items-center space-x-2">
                                {t('btn.close')}
                            </button>
                        </h1>
                        <p>
                            {t('subs.detailsContent1')} {DateUtils.getDay(subscription.start_date)}
                            {t('subs.detailsContent2')} {DateUtils.getDay(subscription.current_period_end)}
                            {t('subs.detailsContent3')}&nbsp;
                            <span className="font-bold cursor-pointer" onClick={() => unsubscribe(true)}>
                                {t('subs.detailsHere')}
                            </span>
                        </p>
                    </div>
                }

                <div
                    className={showMessageClass}
                    role="dialog"
                    tabIndex="-1"
                    aria-labelledby="hs-basic-modal-label"
                    style={{margin: "0px"}}
                    onClick={() => setShowMessage(false)}
                >
                    <div className="sm:max-w-lg sm:w-full m-3 sm:mx-auto">
                        <div
                            className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto">
                            <div className="flex justify-between items-center py-3 px-4 border-b">
                                <h4 id="hs-basic-modal-label" className="font-bold text-gray-800">
                                    {t('subs.canceledTitle')}
                                </h4>
                                <button
                                    type="button"
                                    className="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600"
                                    onClick={() => setShowMessage(false)}
                                >
                                    X
                                </button>
                            </div>
                            <div className="p-4 overflow-y-auto">
                                <p className="mt-1 text-gray-800 font-bold">
                                    {t('subs.canceledContent1')}
                                    <br/>
                                    <br/>
                                    {t('subs.canceledContent2')}
                                    <br/>
                                    <br/>
                                    {t('subs.canceledContent3')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MySubscriptionPage;